import PropTypes from "prop-types";

// material-ui
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

// project import
import MainCard from "./MainCard";

import { ArrowUpward, ArrowDownward } from "@mui/icons-material";
import { useTheme } from "@emotion/react";

const iconSX = {
  fontSize: "0.75rem",
  color: "inherit",
  marginLeft: 0,
  marginRight: 0,
};

export default function AnalyticsCards({
  color = "primary",
  title,
  count,
  percentage,
  isLoss,
  extra,
}) {
  const theme = useTheme();
  return (
    <MainCard
      contentSX={{ p: 2.25 }}
      sx={{
        borderRadius: "2px",
        border:
          theme.palette.mode === "dark"
            ? "1px solid #70d8bd"
            : "1px solid #1F2A40",
      }}
    >
      <Stack spacing={0.5}>
        <Typography variant="h6" color="text.secondary">
          {title}
        </Typography>
        <Grid container alignItems="center">
          <Grid item>
            <Typography variant="h4" color="inherit">
              {count}
            </Typography>
          </Grid>
          {percentage && (
            <Grid item>
              <Chip
                variant="combined"
                color={color}
                icon={
                  isLoss ? (
                    <ArrowDownward style={iconSX} />
                  ) : (
                    <ArrowUpward style={iconSX} />
                  )
                }
                label={`${percentage}%`}
                sx={{ ml: 1.25, pl: 1 }}
                size="small"
              />
            </Grid>
          )}
        </Grid>
      </Stack>
      <Box sx={{ pt: 2.25 }}>
        <Typography variant="caption" color="text.secondary">
          You made an extra{" "}
          <Typography
            variant="caption"
            // sx={{ color: `${color || "primary"}.main` }}
          >
            {extra}
          </Typography>{" "}
          this year
        </Typography>
      </Box>
    </MainCard>
  );
}

AnalyticsCards.propTypes = {
  color: PropTypes.string,
  title: PropTypes.string,
  count: PropTypes.string,
  percentage: PropTypes.number,
  isLoss: PropTypes.bool,
  extra: PropTypes.string,
};
